import React from 'react';
import { CampaignStatusProps } from './CampaignStatus.interface';
import { Wrapper } from './CampaignStatus.styles';
import { Status } from '../../statuses';

export function CampaignStatus({ status }: CampaignStatusProps) {
    let color = '';
    let statusText = '';
    switch (status) {
        case Status.Active:
            color = '#00C853';
            break;
        case Status.Closed:
            color = '#062b548a';
            break;
        case Status.Suspended:
            color = '#EA3100';
            break;
        case Status.Scheduled:
            color = '#062B54';
            break;
        case Status.Stopped:
            color = '#F7B500';
            break;
        case Status.WaitingForApproval:
            statusText = 'waiting for approval';
            color = '#A892F1';
            break;
        case Status.NotApproved:
            statusText = 'not approved';
            color = '#EA3100';
            break;
        case Status.Draft:
            color = '#0000008a';
            break;
        default:
            return null;
    }
    return (
        <Wrapper color={color}>
            {status === Status.WaitingForApproval || status === Status.NotApproved
                ? statusText : status
            }
        </Wrapper>
    )
}
